import React from 'react';

const ErrorPage = () => {
     return (
          <div className='mx-auto w-full'>
               <div >
                    <img className='mx-auto mt-16 w-2/5' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTdmbx0hXYD1OHvhb4iXNtbTDr9nqyu_l5-yoypTluo-K5Cqa53Br8-9UPnWJe68dStgM&usqp=CAU" alt="" />
               </div>
          </div>
     );
};

export default ErrorPage;